module.exports = __webpack_public_path__ + "static/img/14000668.f17c8bd6.png";